<template>
  <div class="popup-modal" v-if="isVisible">
    <div class="window">
      <div>
        <h2 style="margin-top: 0; font-size: 20pt; margin-bottom: 20px">
          {{ title }}
        </h2>
        <p style="font-size: 12pt; margin-bottom: 20px">{{ message }}</p>
        <div class="btns">
          <span class="ok-btn" @click="_confirm">{{ okButton }}</span>
          <button class="cancel-btn" @click="_cancel">
            {{ cancelButton }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupModal",

  data: () => ({
    isVisible: false,
    title: undefined,
    message: undefined,
    okButton: undefined,
    cancelButton: "Cancel",
    resolvePromise: undefined,
    rejectPromise: undefined,
    isConfirm: false
  }),

  methods: {
    show(opts = {}) {
      this.title = opts.title;
      this.message = opts.message;
      this.okButton = opts.okButton;
      this.isConfirm = opts.isConfirm;
      
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton;
      }
      this.isVisible = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    _confirm() {
      this.isVisible = false;
      this.resolvePromise(true);
    },

    _cancel() {
      this.isVisible = false;
      this.resolvePromise(false);
    },
  },
};
</script>

<style scoped>
/* css class for the transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.popup-modal {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  z-index: 6;
}

.window {
  background: #fff;
  border-radius: 5px;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
  text-align: left;
}

.btns {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.ok-btn {
  font-size: 12pt;
  background-color: rgb(89, 189, 89);
  color: white;
  cursor: pointer;
  border-radius: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

.cancel-btn {
  font-size: 12pt;
  background-color: rgb(196, 82, 82);
  color: white;
  cursor: pointer;
  border-radius: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border:none;
}
</style>